// PartnerCard.tsx
import React from 'react'
import classNames from 'classnames'
import Skeleton from 'react-loading-skeleton'
import { ReactSVG } from 'react-svg'
import BtnIcon from './BtnIcon'
import { Link } from 'react-router-dom'
import { ArticleData } from '../server/utils/getArticlesData'

interface ContactItems {
  title: string
  text: string
  href?: string
}

interface PartnerCardProps extends Partial<ArticleData> {
  loading?: boolean
  className?: string
  picture?: string
  link?: string
  titleTag?: React.ElementType
  titleHref?: string
  contactItems?: ContactItems[]
}

const PartnerCard: React.FC<PartnerCardProps> = ({
  loading = false,
  className = '',
  picture,
  title,
  link = '#',
  titleTag = 'h4',
  contactItems,
  socials
}) => {
  const TitleTag = titleTag

  const getDomainName = (url: string): string => {
    try {
      const parsedUrl = new URL(url)
      return parsedUrl.hostname
    } catch (error) {
      console.error('Error parsing URL:', error)
      return ''
    }
  }

  return (
    <article className={classNames('partner-card', className)}>
      <div className={'partner-card__picture'}>
        {loading ? (
          <Skeleton height={'100%'} width={'100%'} />
        ) : (
          picture && <img src={picture} alt={title} />
        )}
      </div>
      <div className={'partner-card__inner'}>
        <div className={'partner-card__content'}>
          {loading ? (
            <>
              <TitleTag className={'partner-card__title text-h4'}>
                <Skeleton count={2} />
              </TitleTag>
              <div className={'partner-card__contacts'}>
                <Skeleton height={'3rem'} count={6} />{' '}
              </div>
              <div className="partner-card__socials">
                {Array.from({ length: 2 }).map((_, index) => (
                  <Skeleton
                    key={index}
                    height={'2.4rem'}
                    width={'2.4rem'}
                    style={{ marginBottom: index === 0 ? '0.8rem' : 0 }}
                  />
                ))}
              </div>
            </>
          ) : (
            <>
              <TitleTag className={'partner-card__title text-h4'}>
                <Link to={link}>{title}</Link>
              </TitleTag>
              <p className={'partner-card__link'}>{getDomainName(link)}</p>

              {contactItems && contactItems?.length > 0 && (
                <div className={'partner-card__contacts'}>
                  {contactItems.map((item, index) => (
                    <div key={index} className={'partner-card__contacts-item'}>
                      <p className={'partner-card__contacts-title'}>
                        {item.title}
                      </p>
                      {item.href ? (
                        <a
                          className={'partner-card__contacts-text'}
                          href={item.href}
                        >
                          {item.text}
                        </a>
                      ) : (
                        <p className={'partner-card__contacts-text'}>
                          {item.text}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {socials && socials?.length > 0 && (
                <div className="partner-card__socials">
                  {socials.map(({ icon, href }, index) => (
                    <BtnIcon
                      key={index}
                      to={href}
                      filled
                      className="partner-card__socials-item"
                    >
                      <ReactSVG
                        className="svg-icon"
                        src={`/i/svg/${icon}.svg`}
                        wrapper={'span'}
                      />
                    </BtnIcon>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </article>
  )
}

export default PartnerCard
